var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 48C9.5 26.4723 26.9723 9 48.5 9C70.0277 9 87.5 26.4723 87.5 48C87.5 69.5277 70.0277 87 48.5 87C26.9723 87 9.5 69.5277 9.5 48ZM53.5 64V53H64.5C67.2523 53 69.5 50.7523 69.5 48C69.5 45.2477 67.2523 43 64.5 43H53.5V32C53.5 29.2477 51.2523 27 48.5 27C45.7477 27 43.5 29.2477 43.5 32V43H32.5C29.7477 43 27.5 45.2477 27.5 48C27.5 50.7523 29.7477 53 32.5 53H43.5V64C43.5 66.7523 45.7477 69 48.5 69C51.2523 69 53.5 66.7523 53.5 64Z",
    fill: "url(#paint0_linear_9_287)",
    stroke: "#456EEB",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_287",
    x1: 48.5,
    y1: 8,
    x2: 48.5,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244ECC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.cc12a35cf6d603c2300e2f9dee710e9b.svg";
export { ForwardRef as ReactComponent };